import camelCase from 'lodash/camelCase';
import { eventActions } from '../../../actions';
import { segmentConfigSelectors } from '../../../selectors';
import * as analyticsEvents from '../events';

const handlePiggybankOnNavigateEvent = (state, action) => {
  const {
    event: { currentPageName, ...rest },
    pageNameBeforeTransition,
  } = action;

  if (pageNameBeforeTransition) {
    analyticsEvents.trackEventsForPage(pageNameBeforeTransition, {
      ...action.event,
      state,
    });
  }

  return analyticsEvents.trackPageView({
    ...rest,
    keyPath: {
      pageName: camelCase(currentPageName),
    },
    state,
  });
};

const handlePiggybankEvent = (state, action = {}) => {
  const { type } = action.event || {};

  switch (type) {
    case 'onNavigate':
      return handlePiggybankOnNavigateEvent(state, action);

    case 'onChange':
      return analyticsEvents.trackEventAtKeyPath(
        {
          ...action.event,
          keyPath: action.event.name,
          state,
        },
        type
      );

    case 'onComponentLoad': {
      const currentPageName =
        action.currentPageName ||
        segmentConfigSelectors.getCurrentSegmentName(state);

      return analyticsEvents.trackPageView({
        ...action.event,
        keyPath: {
          pageName: currentPageName + ':' + action.event.componentName,
        },
        state,
      });
    }

    case 'onComponentClick':
      return analyticsEvents.trackEventAtKeyPath(
        {
          keyPath: [
            action.currentSegmentName,
            action.currentPageName,
            action.event.componentName,
          ],
          value: action.event.value,
          state,
        },
        'onClick'
      );
  }

  return null;
};

export default (state, { type, ...action }) => {
  switch (type) {
    case eventActions.INIT_EVENT: {
      const currentPageName =
        segmentConfigSelectors.getCurrentPageName(state) ||
        segmentConfigSelectors.getCurrentSegmentName(state);

      return analyticsEvents.trackPageView({
        keyPath: {
          pageName: camelCase(currentPageName),
        },
        state,
      });
    }

    case eventActions.ERROR_EVENT:
      return analyticsEvents.trackPageView({
        ...action.event,
        keyPath: {
          pageName: 'technicalError',
        },
        state,
      });

    case eventActions.TRACK_EVENT:
      return analyticsEvents.trackEventAtKeyPath(
        {
          ...action.event,
          state,
        },
        'onClick'
      );

    case eventActions.TRACK_PAGEVIEW_EVENT: {
      const {
        event: { pageName, ...rest },
      } = action;

      return analyticsEvents.trackPageView({
        keyPath: {
          pageName,
        },
        ...rest,
        state,
      });
    }

    case eventActions.PIGGYBANK_EVENT:
      return handlePiggybankEvent(state, action);

    default:
      return null;
  }
};
